var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"current-page":_vm.currentPage4,"page-sizes":[10, 20, 30, 40],"page-size":10,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagecount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }